import React from 'react';
import { Switch, Spin } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeProvider';

const ThemeSwitcher: React.FC = () => {
  const { currentTheme, setTheme, loading } = useTheme();

  const handleThemeChange = async (checked: boolean) => {
    const themeName = checked ? 'dark' : 'light';
    try {
      await setTheme(themeName);
      window.location.reload();
    } catch (error) {
      // Error is already logged in the hook
      // You might want to show a notification here
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {loading ? (
        <Spin size="small" />
      ) : (
        <Switch
          title="Dark Theme"
          checked={currentTheme === 'dark'}
          onChange={handleThemeChange}
          unCheckedChildren={<SunOutlined />}
          checkedChildren={<MoonOutlined />}
        />
      )}
    </div>
  );
};

export default ThemeSwitcher;
